module.exports = __webpack_public_path__ + "img/samspitze.82555360.jpg";